import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

const commonPermissions = [
  Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
  Permissions.CAMPAIGN_TRACKING,
  Permissions.CDC_TIER1_METRICS,
];

export const HELIX_HEALTH_PARTNERS_PRODUCTION = {
  [UserRole.ADMINISTRATOR]: [
    ...commonPermissions,
    Permissions.CAN_VIEW_PHI,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
  [UserRole.EXECUTIVE]: commonPermissions,
  [UserRole.MEMBER_LIMITED_PHI]: commonPermissions,
  [UserRole.MEMBER]: [
    ...commonPermissions,
    Permissions.CAN_VIEW_PHI,
    Permissions.GENETIC_COUNSELING,
    Permissions.GENETIC_COUNSELING__CREATE,
  ],
};
